import { Link, Typography } from '@mui/material';

export const RowInformation = ({ name, value, isLink = false }) => {
  const lenkRegex = new RegExp(/[\w#%+.:=@~-]{1,256}\.[\d()a-z]{1,6}\b([\w#%&()+./:=?@~-]*)/gi);
  const valueIsLink = value?.match(lenkRegex) && isLink;
  return (
    <Typography variant="label12Medium" lineHeight="18px" color="grey.700">
      <Typography variant="label12Bold" lineHeight="18px" color="grey.700" marginRight="8px" noWrap>
        {name}
      </Typography>
      {valueIsLink ? (
        <Link
          target="_blank"
          rel="noreferrer"
          href={value}
          underline="none"
          sx={{ display: 'inline', wordBreak: 'break-all' }}
        >
          {value}
        </Link>
      ) : (
        value || '–'
      )}
    </Typography>
  );
};
